module.exports = __webpack_public_path__ + "img/ventilation.2f72429f.png";